export type CrmContactKind = "person" | "team";

export function normalizeCrmContactKind(value: unknown): CrmContactKind {
  return value === "team" ? "team" : "person";
}

export function crmContactDisplayName(contact: {
  fullName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
}): string {
  const full = contact.fullName?.trim();
  if (full) return full;
  const joined = [contact.firstName, contact.lastName].filter(Boolean).join(" ").trim();
  if (joined) return joined;
  return contact.email?.trim() || "Unknown contact";
}
